webpackJsonp([1,4,5,6,7,8,9,10],{

/***/ "../package.json":
/***/ function(module, exports) {

	module.exports = {
		"name": "keystone",
		"version": "4.0.0-beta.5",
		"description": "Web Application Framework and Admin GUI / Content Management System built on Express.js and Mongoose",
		"main": "index.js",
		"repository": {
			"type": "git",
			"url": "https://github.com/keystonejs/keystone.git"
		},
		"dependencies": {
			"async": "2.1.5",
			"asyncdi": "1.1.0",
			"babel-core": "6.22.1",
			"babel-plugin-transform-object-assign": "6.22.0",
			"babel-polyfill": "6.22.0",
			"babel-preset-es2015": "6.22.0",
			"babel-preset-react": "6.22.0",
			"babel-preset-stage-2": "6.22.0",
			"babelify": "7.3.0",
			"babyparse": "0.4.6",
			"bcrypt-nodejs": "~0.0.3",
			"blacklist": "1.1.4",
			"body-parser": "1.17.0",
			"brfs": "1.4.3",
			"browserify": "13.3.0",
			"browserify-shim": "3.8.13",
			"caller-id": "0.1.0",
			"chalk": "1.1.3",
			"classnames": "2.2.5",
			"cloudinary": "1.7.1",
			"cloudinary-microurl": "1.0.2",
			"compression": "1.6.2",
			"connect-flash": "0.1.1",
			"cookie-parser": "1.4.3",
			"debug": "2.6.1",
			"display-name": "0.1.0",
			"ejs": "2.5.6",
			"elemental": "0.6.1",
			"embedly": "2.1.0",
			"errorhandler": "1.5.0",
			"es6-promise": "4.0.5",
			"express": "4.15.0",
			"express-request-language": "1.1.9",
			"express-session": "1.15.1",
			"expression-match": "0.0.17",
			"fs-extra": "1.0.0",
			"glamor": "^2.20.24",
			"grappling-hook": "3.0.0",
			"i": "0.3.5",
			"kerberos": "0.0.22",
			"keystone-storage-namefunctions": "1.1.1",
			"keystone-utils": "0.4.0",
			"knox": "0.9.2",
			"less-middleware": "2.2.0",
			"letsencrypt-express": "2.0.6",
			"list-to-array": "1.1.0",
			"lodash": "4.17.4",
			"marked": "0.3.6",
			"method-override": "2.3.7",
			"mime-types": "2.1.14",
			"moment": "2.17.1",
			"mongoose": "4.8.5",
			"morgan": "1.8.1",
			"multer": "0.1.8",
			"numeral": "2.0.4",
			"object-assign": "4.1.1",
			"qs": "4.0.0",
			"queryfilter": "0.0.4",
			"range_check": "1.4.0",
			"react": "15.4.2",
			"react-addons-css-transition-group": "15.4.2",
			"react-alt-text": "2.0.0",
			"react-color": "2.11.1",
			"react-day-picker": "2.5.0",
			"react-dnd": "2.2.4",
			"react-dnd-html5-backend": "2.2.4",
			"react-dom": "15.4.2",
			"react-domify": "0.2.6",
			"react-images": "0.5.2",
			"react-markdown": "2.4.5",
			"react-redux": "5.0.3",
			"react-router": "3.0.2",
			"react-router-redux": "4.0.8",
			"react-select": "1.0.0-rc.1",
			"redux": "3.6.0",
			"redux-saga": "0.14.3",
			"redux-thunk": "2.2.0",
			"sanitize-filename": "1.6.1",
			"scmp": "1.0.2",
			"semver": "5.3.0",
			"serve-favicon": "2.4.1",
			"string-to-stream": "1.1.0",
			"vkey": "1.0.1",
			"watchify": "3.8.0",
			"xhr": "2.4.0"
		},
		"devDependencies": {
			"@ljharb/eslint-config": "^11.0.0",
			"browserify-middleware": "7.1.0",
			"codeclimate-test-reporter": "0.4.1",
			"connect-mongo": "1.3.2",
			"core-assert": "0.2.1",
			"cross-env": "3.1.4",
			"disc": "1.3.2",
			"enzyme": "2.7.1",
			"eslint": "3.17.0",
			"eslint-config-keystone": "3.0.0",
			"eslint-config-keystone-react": "1.0.0",
			"eslint-config-postcss": "^2.0.2",
			"eslint-plugin-react": "6.9.0",
			"istanbul": "0.4.5",
			"keystone-email": "1.0.5",
			"keystone-nightwatch-e2e": "0.2.14",
			"mocha": "3.2.0",
			"must": "0.13.4",
			"proxyquire": "1.7.11",
			"react-addons-test-utils": "15.4.2",
			"react-engine": "4.3.0",
			"rimraf": "2.6.1",
			"sinon": "1.17.7",
			"superagent": "3.5.0",
			"supertest": "3.0.0",
			"uglify-js": "2.8.5",
			"updtr": "0.2.3",
			"watch": "1.0.2"
		},
		"browserify": {
			"transform": [
				"browserify-shim"
			]
		},
		"browserify-shim": {
			"tinymce": "global:tinymce",
			"jquery": "global:$",
			"codemirror": "global:CodeMirror",
			"underscore": "global:_"
		},
		"author": "Jed Watson",
		"homepage": "http://keystonejs.com/",
		"license": "MIT",
		"keywords": [
			"express",
			"web",
			"app",
			"cms",
			"admin",
			"framework",
			"mongoose",
			"gui",
			"site",
			"website",
			"forms"
		],
		"readmeFilename": "README.md",
		"gitHead": "ef3fd612285315ea8e12f68da4c8d6031e2c7fe7",
		"bugs": {
			"url": "https://github.com/keystonejs/keystone/issues"
		},
		"scripts": {
			"build": "cross-env NODE_ENV=production node build.js | uglifyjs -mc warnings=false,screw_ie8=true -b beautify=false,semicolons=false > ./admin/public/js/packages.js",
			"build-dev": "node build.js > ./admin/public/js/packages.js",
			"pretest": "npm run lint && node test/pretest.js",
			"test": "mocha && mocha --opts test/mocha-admin.opts",
			"test-all": "npm test && npm run test-e2e-bg",
			"test-unit": "node test/pretest.js && mocha",
			"test-admin": "mocha --opts test/mocha-admin.opts",
			"test-e2e": "node test/e2e/server.js --env default",
			"test-e2e-bg": "cross-env KNE_SELENIUM_START_PROCESS=false && node test/e2e/server.js --env default",
			"test-e2e-saucelabs": "if [ -n \"$SAUCE_ACCESS_KEY\" ]; then node test/e2e/server.js --env saucelabs-travis; fi",
			"test-e2e-saucelabs-group": "if [ -n \"$SAUCE_ACCESS_KEY\" ]; then node test/e2e/server.js --env saucelabs-travis --group ./test/e2e/adminUI/tests/$GROUP; fi",
			"lint": "eslint .",
			"lint-fix": "eslint . --fix",
			"watch": "watch 'clear && npm run lint' lib admin server test",
			"pretest-cov": "npm run clean && npm run lint",
			"current": "updtr",
			"test-cov": "istanbul cover ./node_modules/mocha/bin/_mocha",
			"posttest-cov": "if [ -n \"$CODECLIMATE_REPO_TOKEN\" ]; then codeclimate-test-reporter < coverage/lcov.info; fi",
			"clean": "rimraf ./coverage",
			"fields-explorer": "node ./fields/explorer/server.js"
		}
	};

/***/ },

/***/ "./images/brand-continental.png":
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ "./images/brand-event_cinemas.png":
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ "./images/brand-macmillan.png":
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ "./images/brand-sony.png":
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ "./images/brand-vodafone.png":
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ "./images/brand-westpac.png":
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ "./images/keystone_admin.png":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/keystone_admin.08120ec3.png";

/***/ },

/***/ "./images/logo-inverted.svg":
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMTAwIDEwMS40IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDAgMTAxLjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik05NS42LDBINC40QzIsMCwwLDIsMCw0LjV2OTIuNWMwLDIuNSwyLDQuNSw0LjQsNC41aDkxLjJjMi40LDAsNC40LTIsNC40LTQuNVY0LjVDMTAwLDIsOTgsMCw5NS42LDB6DQoJCQkgTTYzLjgsODYuOEw0Mi40LDU3LjhsLTUuNSw2Ljd2MjIuM0gyMi4zdi03MmgxNC41djMyLjJsMjUtMzIuMmgxOC41TDUyLjMsNDguNWwzMCwzOC4zSDYzLjh6Ii8+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ },

/***/ "./node_modules/react-tweet-embed/dist/tweet-embed.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var callbacks = [];
	
	function addScript(src, cb) {
	  if (callbacks.length === 0) {
	    callbacks.push(cb);
	    var s = document.createElement('script');
	    s.setAttribute('src', src);
	    s.onload = function () {
	      return callbacks.forEach(function (cb) {
	        return cb();
	      });
	    };
	    document.body.appendChild(s);
	  } else {
	    callbacks.push(cb);
	  }
	}
	
	var TweetEmbed = function (_React$Component) {
	  _inherits(TweetEmbed, _React$Component);
	
	  function TweetEmbed() {
	    _classCallCheck(this, TweetEmbed);
	
	    return _possibleConstructorReturn(this, (TweetEmbed.__proto__ || Object.getPrototypeOf(TweetEmbed)).apply(this, arguments));
	  }
	
	  _createClass(TweetEmbed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var options = this.props.options || {};
	
	      var renderTweet = function renderTweet() {
	        window.twttr.widgets.createTweetEmbed(_this2.props.id, _this2._div, options);
	      };
	
	      if (!window.twttr) {
	        var protocol = window.location.protocol.indexOf('file') >= 0 ? this.props.protocol : '';
	
	        addScript(protocol + '//platform.twitter.com/widgets.js', renderTweet);
	      } else {
	        renderTweet();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('div', { ref: function ref(c) {
	          _this3._div = c;
	        } });
	    }
	  }]);
	
	  return TweetEmbed;
	}(_react2.default.Component);
	
	TweetEmbed.propTypes = {
	  id: _react.PropTypes.string,
	  options: _react.PropTypes.object,
	  protocol: _react.PropTypes.string
	};
	
	TweetEmbed.defaultProps = {
	  protocol: 'https:'
	};
	
	exports.default = TweetEmbed;

/***/ },

/***/ "./pages/components/home/AdminInterface.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	var _keystone_admin = __webpack_require__("./images/keystone_admin.png");
	
	var _keystone_admin2 = _interopRequireDefault(_keystone_admin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValueProps = function (_Component) {
		_inherits(ValueProps, _Component);
	
		function ValueProps() {
			_classCallCheck(this, ValueProps);
	
			return _possibleConstructorReturn(this, (ValueProps.__proto__ || Object.getPrototypeOf(ValueProps)).apply(this, arguments));
		}
	
		_createClass(ValueProps, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					'div',
					{ className: (0, _glamor.compose)(styles.wrapper) },
					Glamor.createElement(
						_Container2.default,
						{ style: { paddingBottom: '0' } },
						Glamor.createElement(
							'h2',
							{ className: (0, _glamor.compose)(styles.heading) },
							'Admin Interface'
						),
						Glamor.createElement(
							'p',
							{ className: (0, _glamor.compose)(styles.subheading) },
							'Keystone gives you a beautiful, customisable Admin UI based on your models'
						),
						Glamor.createElement('img', { src: _keystone_admin2.default, className: (0, _glamor.compose)(styles.image) })
					)
				);
			}
		}]);
	
		return ValueProps;
	}(_react.Component);
	
	exports.default = ValueProps;
	;
	
	var styles = {
		wrapper: {
			backgroundColor: _theme2.default.color.lightBlue,
			textAlign: 'center'
		},
		heading: {
			paddingTop: '3em',
			fontSize: '2.6em'
		},
		image: {
			marginBottom: '0',
			display: 'block'
		},
		subheading: {
			paddingTop: '1em',
			fontSize: '1.8em',
			lineHeight: '1.2em',
			paddingBottom: '1em'
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./pages/components/home/CommunityResponse.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Grid = __webpack_require__("./components/Grid/index.js");
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTweetEmbed = __webpack_require__("./node_modules/react-tweet-embed/dist/tweet-embed.js");
	
	var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var niceTweets = ['844728872914616320', '823442524538667010', '804394095854624768', '787050130277007364', '764928277177917440', '758768387719847936', '757966689006858240', '751932694536130560', '751034429393530880', '716007045107957760'];
	
	var ValueProps = function (_Component) {
		_inherits(ValueProps, _Component);
	
		function ValueProps() {
			_classCallCheck(this, ValueProps);
	
			return _possibleConstructorReturn(this, (ValueProps.__proto__ || Object.getPrototypeOf(ValueProps)).apply(this, arguments));
		}
	
		_createClass(ValueProps, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					_Container2.default,
					null,
					Glamor.createElement(
						'h2',
						null,
						'Community Feedback'
					),
					Glamor.createElement(
						'p',
						null,
						'What people have been saying about KeystoneJS:'
					),
					Glamor.createElement(
						_Grid.Row,
						{ small: '1', medium: '1/2', large: '1/3' },
						niceTweets.map(function (tweetID) {
							return Glamor.createElement(
								_Grid.Col,
								{ key: tweetID },
								Glamor.createElement(_reactTweetEmbed2.default, { id: tweetID })
							);
						})
					),
					Glamor.createElement(
						'div',
						null,
						Glamor.createElement(
							_gatsbyLink2.default,
							{ to: '/getting-started', style: { color: 'white' } },
							'Get Started'
						),
						' ',
						Glamor.createElement(
							'a',
							{ href: 'https://demo.keystonejs.com', style: { color: 'white' } },
							'Try the Demo'
						)
					)
				);
			}
		}]);
	
		return ValueProps;
	}(_react.Component);
	
	exports.default = ValueProps;
	;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./pages/components/home/Footer.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValueProps = function (_Component) {
		_inherits(ValueProps, _Component);
	
		function ValueProps() {
			_classCallCheck(this, ValueProps);
	
			return _possibleConstructorReturn(this, (ValueProps.__proto__ || Object.getPrototypeOf(ValueProps)).apply(this, arguments));
		}
	
		_createClass(ValueProps, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					'div',
					{ className: (0, _glamor.compose)(styles.background) },
					Glamor.createElement(
						_Container2.default,
						null,
						Glamor.createElement(
							'p',
							null,
							'Created by ',
							Glamor.createElement(
								'a',
								{ href: 'http://twitter.com/jedwatson', className: (0, _glamor.compose)(styles.list_links_anchor) },
								'@jedwatson'
							),
							', ',
							Glamor.createElement(
								'a',
								{ href: 'http://twitter.com/bladey', className: (0, _glamor.compose)(styles.list_links_anchor) },
								'@bladey'
							),
							' and ',
							Glamor.createElement(
								'a',
								{ href: 'http://twitter.com/jossmackison', className: (0, _glamor.compose)(styles.list_links_anchor) },
								'@jossmackison'
							),
							' at ',
							Glamor.createElement(
								'a',
								{ href: 'http://www.thinkmill.com.au/', className: (0, _glamor.compose)(styles.list_links_anchor) },
								'Thinkmill'
							),
							', and other ',
							Glamor.createElement(
								'a',
								{ href: 'https://github.com/keystonejs/keystone/contributors', className: (0, _glamor.compose)(styles.list_links_anchor) },
								'contributors'
							),
							' under the ',
							Glamor.createElement(
								'a',
								{ href: 'http://opensource.org/licenses/MIT', className: (0, _glamor.compose)(styles.list_links_anchor) },
								'MIT License'
							)
						),
						Glamor.createElement(
							'ul',
							{ className: (0, _glamor.compose)(styles.list_links) },
							Glamor.createElement(
								'li',
								{ className: (0, _glamor.compose)(styles.list_links_item) },
								Glamor.createElement(
									_gatsbyLink2.default,
									{ to: '/getting-started', className: (0, _glamor.compose)(styles.list_links_anchor) },
									'Getting Started'
								)
							),
							Glamor.createElement(
								'li',
								{ className: (0, _glamor.compose)(styles.list_links_item) },
								Glamor.createElement(
									_gatsbyLink2.default,
									{ to: '/documentation', className: (0, _glamor.compose)(styles.list_links_anchor) },
									'Documentation'
								)
							),
							Glamor.createElement(
								'li',
								{ className: (0, _glamor.compose)(styles.list_links_item) },
								Glamor.createElement(
									'a',
									{ className: (0, _glamor.compose)(styles.list_links_anchor), href: 'https://github.com/keystonejs/keystone' },
									'Github Project'
								)
							),
							Glamor.createElement(
								'li',
								{ className: (0, _glamor.compose)(styles.list_links_item) },
								Glamor.createElement(
									'a',
									{ className: (0, _glamor.compose)(styles.list_links_anchor), href: 'https://groups.google.com/forum/#!forum/keystonejs' },
									'Google Group'
								)
							),
							Glamor.createElement(
								'li',
								{ className: (0, _glamor.compose)(styles.list_links_item) },
								Glamor.createElement(
									'a',
									{ className: (0, _glamor.compose)(styles.list_links_anchor), href: 'http://demo.keystonejs.com/' },
									'Demo Website'
								)
							)
						)
					)
				);
			}
		}]);
	
		return ValueProps;
	}(_react.Component);
	
	exports.default = ValueProps;
	;
	
	var styles = {
		list_links: {
			listStyle: 'none',
			marginLeft: '0',
			marginBottom: '0'
		},
		list_links_item: {
			display: 'inline-block',
			paddingLeft: '1.1em',
			paddingRight: '1.1em'
		},
		list_links_anchor: {
			textDecoration: 'none',
			color: _theme2.default.color.gray90
		},
		background: {
			backgroundColor: _theme2.default.color.gray05,
			paddingTop: '1em',
			paddingBottom: '1em',
			width: '100%',
			textAlign: 'center',
			color: _theme2.default.color.gray50
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./pages/components/home/ValueProps.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Grid = __webpack_require__("./components/Grid/index.js");
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _reactEntypo = __webpack_require__("./node_modules/react-entypo/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValueProp = function ValueProp(_ref) {
		var icon = _ref.icon,
		    text = _ref.text,
		    title = _ref.title,
		    text2 = _ref.text2,
		    marginTop = _ref.marginTop;
	
		return Glamor.createElement(
			'div',
			(0, _glamor.compose)(styles.base, { marginTop: marginTop }),
			Glamor.createElement(
				'i',
				(0, _glamor.compose)(styles.icon_inner),
				icon
			),
			Glamor.createElement(
				'div',
				(0, _glamor.compose)(styles.content),
				Glamor.createElement(
					'h3',
					(0, _glamor.compose)(styles.title),
					title
				),
				Glamor.createElement(
					'p',
					(0, _glamor.compose)(styles.text),
					text
				),
				text2 ? Glamor.createElement(
					'p',
					(0, _glamor.compose)(styles.text),
					text2
				) : null
			)
		);
	};
	
	ValueProp.defaultProps = {
		marginTop: '4em'
	};
	
	var ValueProps = function (_Component) {
		_inherits(ValueProps, _Component);
	
		function ValueProps() {
			_classCallCheck(this, ValueProps);
	
			return _possibleConstructorReturn(this, (ValueProps.__proto__ || Object.getPrototypeOf(ValueProps)).apply(this, arguments));
		}
	
		_createClass(ValueProps, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					_Container2.default,
					{ style: styles.container },
					Glamor.createElement(
						'div',
						{ className: (0, _glamor.compose)(styles.preamble) },
						Glamor.createElement(
							'h2',
							{ className: (0, _glamor.compose)(styles.heading) },
							'Get a head-start on the features you need'
						),
						Glamor.createElement(
							'p',
							{ className: (0, _glamor.compose)(styles.subheading) },
							'KeystoneJS is the easiest way to build database-driven websites, applications and APIs in Node.js.'
						)
					),
					Glamor.createElement(
						_Grid.Row,
						{ medium: '1', large: '1/2' },
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Express.js and MongoDB',
								text: 'Keystone will configure express - the de facto web server for node.js - for you and connect to your MongoDB database using Mongoose, the leading ODM package.',
								icon: Glamor.createElement(_reactEntypo.EntypoLeaf, { style: styles.icon })
							})
						),
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Dynamic Routes',
								text: 'Keystone starts with best practices for setting up your MV* application, and makes it easy to manage your templates, views and routes.',
								icon: Glamor.createElement(_reactEntypo.EntypoShuffle, { style: styles.icon })
							})
						)
					),
					Glamor.createElement(
						_Grid.Row,
						{ medium: '1', large: '1/2' },
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Database Fields',
								text: 'IDs, Strings, Booleans, Dates and Numbers are the building blocks of your database. Keystone builds on these with useful, real-world field types like name, email, password, address, image and relationship fields (and more)',
								icon: Glamor.createElement(_reactEntypo.EntypoImages, { style: styles.icon })
							})
						),
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Auto-generated Admin UI',
								text: 'Whether you use it while you\'re building out your application, or in production as a database content management system, Keystone\'s Admin UI will save you time and make managing your data easy.',
								icon: Glamor.createElement(_reactEntypo.EntypoLightBulb, { style: styles.icon })
							})
						)
					),
					Glamor.createElement(
						_Grid.Row,
						{ medium: '1', large: '1/2' },
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Simpler Code',
								text: 'Sometimes, async code can get complicated to do simple things. Keystone helps keep simple things - like loading data before displaying it in a view - simple.',
								icon: Glamor.createElement(_reactEntypo.EntypoPencil, { style: styles.icon })
							})
						),
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Form Processing',
								text: 'Want to validate a form, upload an image, and update your database with a single line? Keystone can do that, based on the data models you\'ve already defined.',
								icon: Glamor.createElement(_reactEntypo.EntypoDocument, { style: styles.icon })
							})
						)
					),
					Glamor.createElement(
						_Grid.Row,
						{ medium: '1', large: '1/2' },
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Session Management',
								text: 'Keystone comes ready out of the box with session management and authentication features, including automatic encryption for password fields.',
								icon: Glamor.createElement(_reactEntypo.EntypoUsers, { style: styles.icon })
							})
						),
						Glamor.createElement(
							_Grid.Col,
							null,
							Glamor.createElement(ValueProp, {
								title: 'Email Sending',
								text: 'Keystone makes it easy to set up, preview and send template-based emails for your application. It also integrates with Mandrill (Mailchimp\'s excellent transaction email sending service)',
								icon: Glamor.createElement(_reactEntypo.EntypoPaperPlane, { style: styles.icon })
							})
						)
					)
				);
			}
		}]);
	
		return ValueProps;
	}(_react.Component);
	
	exports.default = ValueProps;
	;
	
	var styles = {
		container: { borderBottom: '1px solid ' + _theme2.default.color.gray10 },
		icon: {
			width: '30px',
			height: '30px',
			fill: _theme2.default.color.blue
		},
		preamble: {
			textAlign: 'center'
		},
		heading: {
			fontSize: '2.6em'
		},
		subheading: {
			fontSize: '1.8em',
			lineHeight: '1.2em',
			color: _theme2.default.color.gray40
		},
		base: {
			display: 'flex'
		},
		content: {
			flexGrow: 1
		},
		icon_inner: {
			marginRight: '1em'
		},
		title: {
			color: 'inherit',
			fontWeight: '400',
			marginTop: '0.2em'
		},
		text: {
			paddingTop: '1em',
			fontWeight: '300'
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./pages/components/home/ValueProps2.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Grid = __webpack_require__("./components/Grid/index.js");
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	var _reactEntypo = __webpack_require__("./node_modules/react-entypo/lib/index.js");
	
	var _typography = __webpack_require__("./utils/typography.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValueProp = function ValueProp(_ref) {
		var icon = _ref.icon,
		    text = _ref.text,
		    title = _ref.title,
		    text2 = _ref.text2,
		    marginTop = _ref.marginTop;
	
		return Glamor.createElement(
			'div',
			(0, _glamor.compose)(styles.base, { marginTop: marginTop }),
			Glamor.createElement(
				'i',
				(0, _glamor.compose)(styles.icon),
				icon
			),
			Glamor.createElement(
				'div',
				(0, _glamor.compose)(styles.content),
				Glamor.createElement(
					'h3',
					(0, _glamor.compose)(styles.title),
					title
				),
				Glamor.createElement(
					'p',
					(0, _glamor.compose)(styles.text),
					text
				),
				text2 ? Glamor.createElement(
					'p',
					(0, _glamor.compose)(styles.text),
					text2
				) : null
			)
		);
	};
	
	ValueProp.defaultProps = {
		marginTop: '4em'
	};
	
	var ValueProps = function (_Component) {
		_inherits(ValueProps, _Component);
	
		function ValueProps() {
			_classCallCheck(this, ValueProps);
	
			return _possibleConstructorReturn(this, (ValueProps.__proto__ || Object.getPrototypeOf(ValueProps)).apply(this, arguments));
		}
	
		_createClass(ValueProps, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					'div',
					{ className: (0, _glamor.compose)(styles.wrapper) },
					Glamor.createElement(_reactEntypo.EntypoCloud, { style: { width: '200px', height: '170px', color: _theme2.default.color.blue, marginTop: '-100px', position: 'absolute', right: '8%' } }),
					Glamor.createElement(_reactEntypo.EntypoRocket, { style: { width: '137px', height: '140px', color: _theme2.default.color.blue, marginTop: '-220px', position: 'absolute', left: '8%' } }),
					Glamor.createElement(
						_Container2.default,
						null,
						Glamor.createElement(
							'div',
							{ className: (0, _glamor.compose)(styles.intro) },
							Glamor.createElement(
								'h2',
								{ className: (0, _glamor.compose)(styles.heading) },
								'What you build is up to you.'
							),
							Glamor.createElement(
								'p',
								{ className: (0, _glamor.compose)(styles.subheading) },
								'There are a lot of frameworks that make decisions for you, and many that take decisions away. Keystone doesn\'t do that. Use the features that suit you, and replace the ones that don\'t.'
							),
							Glamor.createElement(_reactEntypo.EntypoTools, { style: { width: '90px', height: '90px' } })
						),
						Glamor.createElement(
							_Grid.Row,
							{ small: '1', medium: '1/2', large: '1/4' },
							Glamor.createElement(
								_Grid.Col,
								null,
								Glamor.createElement(ValueProp, {
									title: 'Built on Express',
									text: 'Keystone can configure Express for you, or you can take over and treat Keystone like any other Express middleware.',
									text2: 'You can also easily integrate it into an existing Express app.',
									marginTop: '1em'
								})
							),
							Glamor.createElement(
								_Grid.Col,
								null,
								Glamor.createElement(ValueProp, {
									title: 'Powered by MongoDB',
									text: 'Keystone uses Mongoose, the leading ODM for node.js and MongoDB, and gives you a single place for your schema, validation rules and logic.',
									text2: 'So anything you can build with MongoDB, you can build with Keystone.',
									marginTop: '1em'
								})
							),
							Glamor.createElement(
								_Grid.Col,
								null,
								Glamor.createElement(ValueProp, {
									title: 'Lightweight and flexible',
									text: 'Keystone is designed to be as light as you want - you can pick and choose the features you want to include.',
									text2: '\\nCreate your own routes, your own database schema, and use any template language you like.',
									marginTop: '1em'
								})
							),
							Glamor.createElement(
								_Grid.Col,
								null,
								Glamor.createElement(ValueProp, {
									title: 'Extendable',
									text: 'One of the greatest things about node.js is the vast number of quality packages available.',
									text2: 'Keystone is designed to let you use any of them, without losing the benefits it provides.',
									marginTop: '1em'
								})
							)
						)
					)
				);
			}
		}]);
	
		return ValueProps;
	}(_react.Component);
	
	exports.default = ValueProps;
	;
	
	var styles = {
		wrapper: {
			backgroundColor: _theme2.default.color.blue,
			color: 'white',
			paddingBottom: '5em'
		},
		intro: {
			paddingBottom: (0, _typography.rhythm)(2),
			paddingTop: (0, _typography.rhythm)(2),
			textAlign: 'center'
		},
		heading: {
			fontSize: '2.6em',
			color: 'white'
		},
		subheading: {
			paddingTop: '1em',
			fontSize: '1.8em',
			lineHeight: '1.2em',
			paddingBottom: '1em'
		},
		base: {
			display: 'flex'
		},
		content: {
			flexGrow: 1
		},
		icon: {
			marginRight: '1em'
		},
		title: {
			color: 'inherit',
			fontWeight: '400',
			marginTop: '0.2em'
		},
		text: {
			paddingTop: '1em',
			fontWeight: '300'
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./pages/components/home/WhereNext.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Grid = __webpack_require__("./components/Grid/index.js");
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValueProps = function (_Component) {
		_inherits(ValueProps, _Component);
	
		function ValueProps() {
			_classCallCheck(this, ValueProps);
	
			return _possibleConstructorReturn(this, (ValueProps.__proto__ || Object.getPrototypeOf(ValueProps)).apply(this, arguments));
		}
	
		_createClass(ValueProps, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					'div',
					{ className: (0, _glamor.compose)(styles.wrapper) },
					Glamor.createElement(
						_Container2.default,
						null,
						Glamor.createElement(
							_Grid.Row,
							{ medium: '1', large: '1/2' },
							Glamor.createElement(
								_Grid.Col,
								{ className: (0, _glamor.compose)(styles.col) },
								Glamor.createElement(
									'h3',
									null,
									Glamor.createElement(
										_gatsbyLink2.default,
										{ to: '/getting-started', className: (0, _glamor.compose)(styles.next__heading) },
										'Get Started \u2192'
									)
								),
								Glamor.createElement(
									'p',
									{ className: (0, _glamor.compose)(styles.next__text) },
									'Sound like what you\'ve been looking for? Check out the getting started guide and learn how to get up and running in less than a minute.'
								)
							),
							Glamor.createElement(
								_Grid.Col,
								{ className: (0, _glamor.compose)(styles.col) },
								Glamor.createElement(
									'h3',
									null,
									Glamor.createElement(
										'a',
										{ href: 'mailto:contact@keystonejs.com', className: (0, _glamor.compose)(styles.next__heading) },
										'Get In Touch \u2192'
									)
								),
								Glamor.createElement(
									'p',
									{ className: (0, _glamor.compose)(styles.next__text) },
									'If you are using Keystone for a project, interested in contributing, or looking for commercial support, we\'d love to hear about it. Please contact us.'
								)
							)
						)
					)
				);
			}
		}]);
	
		return ValueProps;
	}(_react.Component);
	
	exports.default = ValueProps;
	;
	
	var styles = {
		wrapper: {
			paddingTop: '4em',
			paddingBottom: '6em'
		},
		next__heading: {
			fontSize: '1.6em',
			textDecoration: 'none'
		},
		next__text: {
			marginTop: '0.5em',
			fontSize: '1.6em',
			lineHeight: '1.4',
			fontWeight: '200'
		},
		col: {
			paddingRight: '5em'
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./pages/components/home/header/Header.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _typography = __webpack_require__("./utils/typography.js");
	
	var _package = __webpack_require__("../package.json");
	
	var _logoInverted = __webpack_require__("./images/logo-inverted.svg");
	
	var _logoInverted2 = _interopRequireDefault(_logoInverted);
	
	var _reactEntypo = __webpack_require__("./node_modules/react-entypo/lib/index.js");
	
	var _brandContinental = __webpack_require__("./images/brand-continental.png");
	
	var _brandContinental2 = _interopRequireDefault(_brandContinental);
	
	var _brandEvent_cinemas = __webpack_require__("./images/brand-event_cinemas.png");
	
	var _brandEvent_cinemas2 = _interopRequireDefault(_brandEvent_cinemas);
	
	var _brandMacmillan = __webpack_require__("./images/brand-macmillan.png");
	
	var _brandMacmillan2 = _interopRequireDefault(_brandMacmillan);
	
	var _brandSony = __webpack_require__("./images/brand-sony.png");
	
	var _brandSony2 = _interopRequireDefault(_brandSony);
	
	var _brandVodafone = __webpack_require__("./images/brand-vodafone.png");
	
	var _brandVodafone2 = _interopRequireDefault(_brandVodafone);
	
	var _brandWestpac = __webpack_require__("./images/brand-westpac.png");
	
	var _brandWestpac2 = _interopRequireDefault(_brandWestpac);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
		_inherits(Header, _Component);
	
		function Header() {
			_classCallCheck(this, Header);
	
			return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
		}
	
		_createClass(Header, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					'div',
					{ className: (0, _glamor.compose)(styles.wrapper) },
					Glamor.createElement(
						_Container2.default,
						null,
						Glamor.createElement(
							'div',
							{ className: (0, _glamor.compose)(styles.intro) },
							Glamor.createElement('img', { src: _logoInverted2.default, style: { width: '93px' } }),
							Glamor.createElement(
								'h1',
								{ className: (0, _glamor.compose)(styles.intro__title) },
								'Node.js CMS & web application platform'
							),
							Glamor.createElement(
								'p',
								{ className: (0, _glamor.compose)(styles.intro__lead) },
								'Keystone is an open source framework for developing database-driven websites, applications and APIs in Node.js. Built on Express and MongoDB.'
							),
							Glamor.createElement(
								'div',
								{ className: (0, _glamor.compose)(styles.home_header_buttons) },
								Glamor.createElement(
									_gatsbyLink2.default,
									{ to: '/getting-started', className: (0, _glamor.compose)(styles.button_home, styles.button_home_primary) },
									'Get Started'
								),
								' ',
								Glamor.createElement(
									'a',
									{ href: 'https://demo.keystonejs.com', className: (0, _glamor.compose)(styles.button_home, styles.button_home_inverse) },
									'Try the Demo'
								)
							),
							Glamor.createElement(
								'ul',
								{ className: (0, _glamor.compose)(styles.list_links) },
								Glamor.createElement(
									'li',
									{ className: (0, _glamor.compose)(styles.list_item) },
									'Current Version ',
									_package.version
								),
								Glamor.createElement(
									'li',
									{ className: (0, _glamor.compose)(styles.list_links_item) },
									Glamor.createElement(
										'a',
										{ href: 'https://github.com/keystonejs/keystone/blob/master/HISTORY.md', style: { color: 'white' } },
										'What\'s New'
									)
								),
								Glamor.createElement(
									'li',
									{ className: (0, _glamor.compose)(styles.list_item) },
									'Free and Open Source (MIT)'
								)
							),
							Glamor.createElement(
								'ul',
								{ className: (0, _glamor.compose)(styles.list_links) },
								Glamor.createElement(
									'li',
									{ className: (0, _glamor.compose)(styles.list_links_item) },
									Glamor.createElement(_reactEntypo.EntypoDocuments, null),
									' ',
									Glamor.createElement(
										_gatsbyLink2.default,
										{ to: '/documentation', style: { color: 'white' } },
										'Read the Documentation'
									)
								),
								Glamor.createElement(
									'li',
									{ className: (0, _glamor.compose)(styles.list_links_item) },
									Glamor.createElement(
										'a',
										{ href: 'https://twitter.com/keystonejs', style: { color: 'white' } },
										Glamor.createElement(_reactEntypo.EntypoTwitter, null),
										' Follow @KeysoneJS on Twitter'
									)
								),
								Glamor.createElement(
									'li',
									{ className: (0, _glamor.compose)(styles.list_links_item) },
									Glamor.createElement(
										'a',
										{ href: 'http://github.com/keystonejs/keystone', style: { color: 'white' } },
										Glamor.createElement(_reactEntypo.EntypoGithub, null),
										' Star on GitHub'
									)
								)
							),
							Glamor.createElement(
								'p',
								{ className: (0, _glamor.compose)(styles.heading_text) },
								'Keystone powers websites, apps and APIs for:'
							),
							Glamor.createElement(
								'div',
								{ className: (0, _glamor.compose)(styles.home_header_brands) },
								Glamor.createElement('img', { src: _brandContinental2.default, className: (0, _glamor.compose)(styles.header_brand_img) }),
								Glamor.createElement('img', { src: _brandWestpac2.default, className: (0, _glamor.compose)(styles.header_brand_img) }),
								Glamor.createElement('img', { src: _brandSony2.default, className: (0, _glamor.compose)(styles.header_brand_img) }),
								Glamor.createElement('img', { src: _brandEvent_cinemas2.default, className: (0, _glamor.compose)(styles.header_brand_img) }),
								Glamor.createElement('img', { src: _brandVodafone2.default, className: (0, _glamor.compose)(styles.header_brand_img) }),
								Glamor.createElement('img', { src: _brandMacmillan2.default, className: (0, _glamor.compose)(styles.header_brand_img) })
							)
						)
					)
				);
			}
		}]);
	
		return Header;
	}(_react.Component);
	
	exports.default = Header;
	;
	
	var styles = {
		wrapper: {
			background: 'linear-gradient(160deg, #34b6d9, #3464d9)',
			color: 'white'
		},
		image: {
			maxWidth: '93px'
		},
		// intro
		intro: {
			paddingBottom: (0, _typography.rhythm)(2),
			paddingTop: (0, _typography.rhythm)(2),
			textAlign: 'center'
		},
		intro__title: {
			marginTop: '0.7em',
			color: 'inherit',
			fontSize: '3.1em',
			fontWeight: '200',
			marginBottom: '0.5em'
		},
		intro__lead: {
			color: 'inherit',
			fontSize: '1.7em',
			fontWeight: '300',
			opacity: '0.7',
			lineHeight: '1.3em'
		},
		list_links: {
			listStyle: 'none'
		},
		list_links_item: {
			display: 'inline-block',
			paddingRight: '10px',
			color: 'inherit',
			fontSize: '1.2em'
		},
		list_item: {
			display: 'inline-block',
			paddingRight: '10px',
			color: 'inherit',
			opacity: '0.7'
		},
		home_header_buttons: {
			marginTop: '8em',
			marginBottom: '2.6em'
		},
		heading_text: {
			marginTop: '4em',
			opacity: '0.6',
			fontSize: '1.2em',
			marginBottom: '0'
		},
		button_home: {
			textTransform: 'uppercase',
			margin: '0.2em',
			fontSize: '1.33em',
			textDecoration: 'none',
			paddingLeft: '2.3em',
			paddingRight: '2.3em',
			paddingTop: '0.7em',
			paddingBottom: '0.7em',
			borderRadius: '6px',
			fontWeight: '300',
			border: '2px solid white'
		},
		button_home_primary: {
			backgroundColor: 'white',
			color: _theme2.default.color.blue
		},
		button_home_inverse: {
			color: 'white'
		},
		home_header_brands: {
			width: '100%',
			flexFlow: 'row-wrap'
		},
		header_brand_img: {
			padding: '20px'
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./pages/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__("./pages/components/home/header/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ValueProps = __webpack_require__("./pages/components/home/ValueProps.js");
	
	var _ValueProps2 = _interopRequireDefault(_ValueProps);
	
	var _CommunityResponse = __webpack_require__("./pages/components/home/CommunityResponse.js");
	
	var _CommunityResponse2 = _interopRequireDefault(_CommunityResponse);
	
	var _AdminInterface = __webpack_require__("./pages/components/home/AdminInterface.js");
	
	var _AdminInterface2 = _interopRequireDefault(_AdminInterface);
	
	var _ValueProps3 = __webpack_require__("./pages/components/home/ValueProps2.js");
	
	var _ValueProps4 = _interopRequireDefault(_ValueProps3);
	
	var _WhereNext = __webpack_require__("./pages/components/home/WhereNext.js");
	
	var _WhereNext2 = _interopRequireDefault(_WhereNext);
	
	var _Footer = __webpack_require__("./pages/components/home/Footer.js");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomePage = function (_Component) {
		_inherits(HomePage, _Component);
	
		function HomePage() {
			_classCallCheck(this, HomePage);
	
			return _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).apply(this, arguments));
		}
	
		_createClass(HomePage, [{
			key: 'render',
			value: function render() {
				return Glamor.createElement(
					'div',
					null,
					Glamor.createElement(_Header2.default, null),
					Glamor.createElement(_ValueProps2.default, null),
					Glamor.createElement(_CommunityResponse2.default, null),
					Glamor.createElement(_AdminInterface2.default, null),
					Glamor.createElement(_ValueProps4.default, null),
					Glamor.createElement(_WhereNext2.default, null),
					Glamor.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return HomePage;
	}(_react.Component);
	
	exports.default = HomePage;
	;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ }

});


// WEBPACK FOOTER //
// page-component---pages-index-js-a65ad9e448172241fedf.js